export default __webpack_public_path__ + "static/media/telegram_auth.a371df2a.png";